'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _easing = require('../animation/easing');

var maxDuration = void 0,
    minDuration = void 0,
    maxDurHeight = void 0,
    wheelEventName = void 0,
    jmpTmpMaxDuration = void 0,
    jmpTmpMinDuration = void 0,
    optionsUser = void 0,
    element = void 0,
    start = void 0,
    stop = void 0,
    offset = void 0,
    easing = void 0,
    durationEasing = void 0,
    a11y = void 0,
    distance = void 0,
    duration = void 0,
    timeStart = void 0,
    timeElapsed = void 0,
    nextScroll = void 0,
    callback = void 0,
    animationID = void 0;

function init(mxDur, mnDur, mxDurHeight) {
    minDuration = mnDur || 750;
    maxDuration = (mxDur || 1500) - minDuration;
    maxDurHeight = mxDurHeight || 5000;

    var pageHeight = getDocumentHeight() - getViewportHeight() * 0.5;

    if (maxDurHeight > pageHeight) {
        maxDurHeight = pageHeight;
    }

    easing = _easing.easeInOutQuad;
    durationEasing = _easing.easeOutQuad;
    a11y = false;

    if ('onwheel' in document.createElement('div')) {
        wheelEventName = 'wheel';
    } else {
        wheelEventName = document.onmousewheel !== undefined ? 'mousewheel' : 'DOMMouseScroll';
    }

    addEventListeners();
}

function addEventListeners() {
    document.addEventListener(wheelEventName, cancelAnimation, false);
}

function cancelAnimation() {
    if (animationID !== undefined) {
        cancelAnimationFrame(animationID);
        animationID = undefined;
        timeStart = false;
    }
}

function getDocumentHeight() {
    var body = document.body;
    var html = document.documentElement;

    return Math.max(body.scrollHeight, body.offsetHeight, html.scrollHeight, html.offsetHeight);
}

function getViewportHeight() {
    return Math.max(document.documentElement.clientHeight, window.innerHeight);
}

function top(element) {
    return element.getBoundingClientRect().top + start;
}

function location() {
    return window.scrollY || window.pageYOffset;
}

function loop(timeCurrent) {
    if (!timeStart) {
        timeStart = timeCurrent;
    }

    timeElapsed = timeCurrent - timeStart;

    nextScroll = easing(timeElapsed, start, distance, duration);

    window.scrollTo(0, nextScroll);

    if (timeElapsed < duration) {
        animationID = requestAnimationFrame(loop);
    } else {
        done();
    }
}

function done() {
    window.scrollTo(0, start + distance);

    if (element && a11y) {
        element.setAttribute('tabindex', '-1');
        element.focus();
    }

    if (typeof callback === 'function') {
        callback();
    }

    if (optionsUser) {
        maxDuration = jmpTmpMaxDuration;
        minDuration = jmpTmpMinDuration;
        optionsUser = false;
    }

    animationID = undefined;
    timeStart = false;
}

function jump(target, cb, offset, options) {
    if (!target) {
        return;
    }

    if (options) {
        optionsUser = true;
        jmpTmpMaxDuration = maxDuration;
        jmpTmpMinDuration = minDuration;

        minDuration = options.minDuration || minDuration;
        maxDuration = options.maxDuration ? options.maxDuration - minDuration : maxDuration;
    }

    start = location();
    callback = cb;
    offset = offset || 0;

    switch (typeof target === 'undefined' ? 'undefined' : _typeof(target)) {
        case 'number':
            element = false;
            a11y = false;
            stop = start + target;
            break;

        case 'object':
            element = target;
            stop = top(element);
            break;

        case 'string':
            element = document.querySelector(target);
            stop = top(element);
            break;
    }

    if (element) {
        var dataOffset = +element.getAttribute('data-offset');
        if (dataOffset) {
            offset = dataOffset;
        }
        var dataMinDuration = +element.getAttribute('data-min-duration');
        var dataMaxDuration = +element.getAttribute('data-max-duration');
        minDuration = dataMinDuration || minDuration;
        maxDuration = dataMaxDuration ? dataMaxDuration - minDuration : maxDuration;
    }

    distance = stop - start + offset;
    var durDistance = Math.abs(distance);

    var distanceChange = durDistance / maxDurHeight;
    if (durDistance >= maxDurHeight) {
        distanceChange = 1;
    }

    var durationChangeRate = durationEasing(distanceChange, 0, 1, 1);
    duration = maxDuration * durationChangeRate + minDuration;

    cancelAnimation();
    animationID = requestAnimationFrame(loop);
}

exports.default = {
    init: init,
    jump: jump
};


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/src/ui/jump.js
// module id = ./resources/assets/js/src/ui/jump.js
// module chunks = 0